import { use } from 'react'

import { fetchChatToken } from '@app/api'
import { ChatContext } from '@app/context'

import { logger } from '@lib/utils'

export const tokenRefresher = async () => {
  const { dispatch } = use(ChatContext)
  try {
    const refreshedTokenResponse = await fetchChatToken()
    dispatch({
      type: 'REFRESH_ACS_TOKEN_SUCCESS',
      payload: { acsChatToken: refreshedTokenResponse.acsChatToken },
    })
    return refreshedTokenResponse.acsChatToken.token
  } catch (error) {
    logger('Token refresh failed', error, 'red')
  }
}
